var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzle(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#191620",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.387 22.212l2.327-2.327 5.536-5.536a.741.741 0 000-1.048l-.433-.44-2.759-2.757s-1.075-1.075-.55-1.862c.524-.786 1.179-.655 1.179-.655s.917.131 1.572-.524c.918-.917 1.24-2.288.126-3.402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.385 3.661l.066.066c-1.114-1.114-2.485-.792-3.402.125-.655.655-.524 1.573-.524 1.573s.13.655-.656 1.18c-.786.523-1.86-.552-1.86-.552l-2.726-2.725-.517-.51a.741.741 0 00-1.048 0L8.993 5.541s-1.076 1.075-.551 1.862c.524.786 1.179.655 1.179.655s.917-.131 1.573.524c.917.917 1.24 2.288.125 3.402l.066-.066c-1.114 1.114-2.485.792-3.402-.125-.655-.656-.524-1.573-.524-1.573s.13-.655-.655-1.18c-.787-.523-1.862.552-1.862.552L2.184 12.35c-.29.29-.322.791-.033 1.08l10.484 10.484c.29.29.759.29 1.049 0l1.703-1.703"
  }))));
}

export default SvgPuzzle;